import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useApp();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const finish = async () => {
      if (!sessionId) { navigate("/profile", { replace: true }); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
      } catch {}
      window.history.replaceState(null, "", "/profile");
      navigate("/profile", { replace: true });
    };
    finish();
  }, [location, navigate, setUser]);

  return (
    <div className="grid min-h-screen place-items-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-terracotta border-t-transparent" />
        <p className="text-sm text-ink-muted">…</p>
      </div>
    </div>
  );
}
